export default {
  log: {},
  GA: ['UA-141211537-1'],
  idle: {
    name: 'idle',
    time: 6 * 600000,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
  },
};
